import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import Slider from 'react-slick';
import { Container } from 'reactstrap';

import 'Components/Carousel/FeaturedCarousel.scss';
import 'Components/Carousel/PreviewFeaturedCarouselSlide.scss';

import CarouselArrow from 'Components/Carousel/CarouselArrow';
import FeaturedCarouselSlide from 'Components/Carousel/FeaturedCarouselSlide';

const PreviewFeaturedCarouselSlide = ({
  carousel,
  siteTheme,
}) => {
  if (isEmpty(carousel)) return false;

  const settings = {
    arrows: true,
    prevArrow: <CarouselArrow ariaLabel="Previous" arrowDirection="left" containerClassName="arrow-btn-container FeaturedCarousel__arrows" />,
    nextArrow: <CarouselArrow ariaLabel="Next" arrowDirection="right" containerClassName="arrow-btn-container FeaturedCarousel__arrows" />,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 8000,
    dots: true,
    dotsClass: 'FeaturedCarousel__pagination',
    slidesToScroll: 1,
    slidesToShow: 1,
    accessibility: true,
    speed: 300,
    fade: true,
    lazyLoad: null,
    customPaging: () => (
      <div className="mobile-friendly-dots" />
    ),
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          fade: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          fade: false,
          customPaging: () => (
            <div className="mobile-friendly-dots" />
          ),
        },
      },
      {
        breakpoint: 767,
        settings: {
          fade: false,
          arrows: false,
          customPaging: () => (
            <div className="mobile-friendly-dots" />
          ),
        },
      },
      {
        breakpoint: 480,
        settings: {
          fade: false,
          arrows: false,
          customPaging: () => (
            <div className="mobile-friendly-dots" />
          ),
        },
      },
    ],
  };

  let carouselTheme = 'dark';
  if (siteTheme === 'light') carouselTheme = 'light';

  return (
    <div className="preview-carousel-banner">
      <Container className="pt-5">
        <h1>Carousel Banner Preview</h1>
      </Container>

      <div className="desktop-preview-container">
        <section
          className={classNames(
            'FeaturedCarousel',
            { 'FeaturedCarousel--dark': carouselTheme === 'dark' },
            { 'FeaturedCarousel--light': carouselTheme === 'light' },
          )}
        >
          <Slider
            {...settings}
            className="FeaturedCarousel__slidesContainer"
          >
            <FeaturedCarouselSlide
              slideNumber={0}
              slide={carousel}
            />
          </Slider>
        </section>
      </div>
    </div>
  );
};

PreviewFeaturedCarouselSlide.propTypes = {
  carousel: PropTypes.shape({}),
};

PreviewFeaturedCarouselSlide.defaultProps = {
  carousel: {},
};


const mapStateToProps = ({
  siteTheme,
}) => ({
  siteTheme,
});

export default connect(mapStateToProps)(PreviewFeaturedCarouselSlide);
